import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownField } from '@ane/ui-components/lib/components/FormikFormFields/DropdownField';
import { TextField } from '@ane/ui-components/lib/components/TextField';
import { StepContainer } from '@ane/ui-components/lib/components/StepContainer';
import { dataSourceCreateComponentsName, dataSourceDataTypeList, getCosmosViewDefaultParameter, getPlaceHolder, getValidateMessage, sampleDataSourceDataTypeList, showMSIOption, } from '../../utils/DataSourceFormikSettingsUtils';
import { LocationKeyDetailLabel, } from '../../../DataSourceDetail/components/DataSourceLocation/DataSourceLocation';
import { CreateStepTitle } from '../CreateWizard/CreateSteps';
import { FormHeading } from '@ane/ui-components/lib/components/FormHeading';
import { FormSection } from '@ane/ui-components/lib/components/FormSection';
import { ADLSGen2Location, AzureBlobLocation, CosmosDataLocation, DataLocationDataType, } from '../../../../constants/DataSource.DataLocation.constants';
import _ from 'lodash';
import { AuthenticationType, DataLocationStorageType } from '../../models/DataSourceDataCommon';
import { useState } from 'react';
import { getAAStreamExpiryDaysField, getAAStreamLocationPrefixFields } from './DataLocationFieldConfig';
import { loadServicePrincipalNameListEpicReducer } from '../../ducks/ServicePrincipalList.ducks';
import { loadManagedIdentityNameListEpicReducer } from '../../ducks/ManagedIdentityList.ducks';
import DataLocationAuthtencationFileds from './DataLocationAuthtencationFileds';
import { DataSourceTypes } from '../../../../constants/DataSource.constants';
export function DataLocationInfoComponent(props) {
    var _a, _b, _c, _d, _e, _f;
    const { isCreate } = props;
    const [optionList, setOptionList] = useState([]);
    const dispatch = useDispatch();
    const workspaceId = useSelector((state) => { var _a, _b; return ((_b = (_a = state.currentUserDetails.userAffinity) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.workspaceId) || ''; });
    React.useEffect(() => {
        const _optionList = props.formikProps.values.dataSourceType !== DataSourceTypes.Sample
            ? dataSourceDataTypeList.map(({ DataType, StorageType, FileFormat }) => ({
                key: StorageType,
                text: DataType,
                data: { fileFormat: FileFormat, storageType: StorageType },
            }))
            : sampleDataSourceDataTypeList.map(({ DataType, StorageType, FileFormat }) => ({
                key: StorageType,
                text: DataType,
                data: { fileFormat: FileFormat, storageType: StorageType },
            }));
        if (!isCreate) {
            dispatch(loadServicePrincipalNameListEpicReducer.actionCreators.load({ workspaceId: workspaceId }));
            dispatchManagedIdentityNameList();
        }
        setOptionList(_optionList);
    }, [isCreate, workspaceId, dispatch]);
    const dispatchManagedIdentityNameList = () => {
        if (showMSIOption(workspaceId)) {
            dispatch(loadManagedIdentityNameListEpicReducer.actionCreators.load({ workspaceId: workspaceId }));
        }
    };
    const getMTLocationTextField = (Name) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const onChange = (_, option) => {
            var _a, _b, _c, _d;
            let dataLocationForms = (_c = (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageMTList[0]) !== null && _c !== void 0 ? _c : { DataPath: '', EndPoint: '' };
            dataLocationForms = {
                ...dataLocationForms,
                [Name]: option,
            };
            (_d = props.formikProps) === null || _d === void 0 ? void 0 : _d.setFieldValue('storageMTList', [dataLocationForms], true);
        };
        const value = (_c = (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageMTList[0]) === null || _c === void 0 ? void 0 : _c[Name];
        return _getTextField(Name, onChange, value, {
            errorMessage: getValidateMessage(Name, (_g = (_f = (_e = (_d = props.formikProps) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.storageMTList) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g[Name]),
        });
    };
    const getRetentionDaysTextField = () => {
        var _a, _b, _c, _d, _e;
        const values = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values;
        const retentionDaysValue = (values === null || values === void 0 ? void 0 : values.retentionDays) ? values === null || values === void 0 ? void 0 : values.retentionDays.toString() : '';
        const errorMsgValue = (values === null || values === void 0 ? void 0 : values.retentionErrorMsg) ? values.retentionErrorMsg : '';
        const onRetentionDaysChange = (_, option) => {
            var _a;
            (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.setFieldValue('retentionDays', option, true);
        };
        const retentionDaysField = _getTextField('RetentionDays', onRetentionDaysChange, retentionDaysValue, {
            description: 'e.g. 30',
            errorMessage: getValidateMessage('RetentionDays', (_c = (_b = props.formikProps) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.retentionDays),
            required: false,
            labelProps: {
                iconProps: {
                    calloutProps: {
                        content: 'Enter the number of days for which data is guaranteed to exist and is interoperable. Experimenters will be able to create scorecards only for the date range that fits within the retention period.',
                    },
                },
            },
        });
        const onRetentionDayErrorMsgChange = (_, option) => {
            var _a;
            (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.setFieldValue('retentionErrorMsg', option, true);
        };
        const errorMsgField = _getTextField('RetentionDaysErrorMsg', onRetentionDayErrorMsgChange, errorMsgValue, {
            description: 'Please input error message',
            errorMessage: getValidateMessage('RetentionDaysErrorMsg', (_e = (_d = props.formikProps) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.retentionErrorMsg),
            required: false,
        });
        return [retentionDaysField, errorMsgField];
    };
    const _getCommonTextField = (Name) => {
        var _a, _b, _c;
        const onChange = (_, option) => {
            var _a, _b, _c, _d, _e;
            let dataLocationForms = (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageList;
            dataLocationForms = {
                ...(_d = (_c = props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.storageList,
                [Name]: option,
            };
            (_e = props.formikProps) === null || _e === void 0 ? void 0 : _e.setFieldValue('storageList', dataLocationForms, true);
        };
        const value = (_c = (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageList) === null || _c === void 0 ? void 0 : _c[Name];
        return _getTextField(Name, onChange, value);
    };
    const _getTextField = (Name, onChange, value, options) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return (React.createElement(TextField, { label: `${LocationKeyDetailLabel[Name]}`, required: true, isReadOnly: !!props.isReadOnly, ariaLabel: `Please enter ${LocationKeyDetailLabel[Name]}`, description: getPlaceHolder(dataSourceCreateComponentsName.datalocationinfo, Name, (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageType), value: value || '', errorMessage: getValidateMessage(Name, (_e = (_d = (_c = props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.storageList) === null || _e === void 0 ? void 0 : _e[Name], ((_g = (_f = props.formikProps) === null || _f === void 0 ? void 0 : _f.values) === null || _g === void 0 ? void 0 : _g.authenticationType) === AuthenticationType.ServicePrincipal), onChange: onChange, ...options }));
    };
    const _handleDataTypeChange = (option) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const { fileFormat = '', storageType = '' } = (_a = option === null || option === void 0 ? void 0 : option.data) !== null && _a !== void 0 ? _a : {};
        (_b = props.formikProps) === null || _b === void 0 ? void 0 : _b.setFieldValue('storageList', {}, false);
        (_c = props.formikProps) === null || _c === void 0 ? void 0 : _c.setFieldValue('storageMTList', [], false);
        (_d = props.formikProps) === null || _d === void 0 ? void 0 : _d.setFieldValue('parameterList', [], true);
        const currentOptionKey = `${storageType}-${fileFormat}`;
        switch (currentOptionKey) {
            case DataLocationDataType.ADLSGen2CosmosView:
                dispatch(loadServicePrincipalNameListEpicReducer.actionCreators.load({ workspaceId: workspaceId }));
                dispatchManagedIdentityNameList();
                (_e = props.formikProps) === null || _e === void 0 ? void 0 : _e.setFieldValue('parameterList', getCosmosViewDefaultParameter(), true);
                break;
            case DataLocationDataType.CosmosCosmosView:
                dispatchManagedIdentityNameList();
                (_f = props.formikProps) === null || _f === void 0 ? void 0 : _f.setFieldValue('storageList', CosmosDataLocation, true);
                (_g = props.formikProps) === null || _g === void 0 ? void 0 : _g.setFieldValue('parameterList', getCosmosViewDefaultParameter(), true);
                break;
            case DataLocationDataType.AzureBlobParquet:
                dispatchManagedIdentityNameList();
                (_h = props.formikProps) === null || _h === void 0 ? void 0 : _h.setFieldValue('storageList', {
                    ...AzureBlobLocation,
                }, true);
                break;
            case DataLocationDataType.ADLSGen2Parquet:
                dispatch(loadServicePrincipalNameListEpicReducer.actionCreators.load({ workspaceId: workspaceId }));
                dispatchManagedIdentityNameList();
                (_j = props.formikProps) === null || _j === void 0 ? void 0 : _j.setFieldValue('storageList', {
                    ...ADLSGen2Location,
                }, true);
                break;
            case DataLocationDataType.MTParquet:
                (_k = props.formikProps) === null || _k === void 0 ? void 0 : _k.setFieldValue('storageMTList', [{ DataPath: '', EndPoint: '', Region: '' }], true);
                break;
        }
        props.formikProps.setFieldValue('flightList', _.map(props.formikProps.values.flightList, (item) => {
            return {
                ...item,
                Format: '',
                Key: null,
                Definition: null,
                Source: null,
            };
        }), true);
    };
    const _generateDataLocationFields = (isCreate, storageType, data) => {
        var _a, _b;
        switch (storageType) {
            case DataLocationStorageType.MT:
                return [getMTLocationTextField('DataPath'), getMTLocationTextField('EndPoint')];
            default:
                let index = _getTypeIndex((_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageType);
                const dataLocationComponentList = [];
                _.each(data === null || data === void 0 ? void 0 : data[index].LocationProperties, (rawItem, Name) => {
                    if (Name === 'TenantId' || Name === 'Environment')
                        return;
                    if (Name !== 'KeyVaultAuthentication') {
                        dataLocationComponentList.push(_getCommonTextField(Name));
                    }
                });
                return dataLocationComponentList;
        }
    };
    const _getTypeIndex = (type) => {
        let index = 0;
        _.each(optionList, (item, key) => {
            if (item.key === type) {
                index = key;
            }
        });
        return index;
    };
    let dataLocationComponent = [];
    if ((_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageType) {
        dataLocationComponent = _generateDataLocationFields(isCreate, (_d = (_c = props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.storageType, dataSourceDataTypeList);
    }
    const _generateOptionalFields = () => {
        var _a, _b;
        const storageType = (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageType;
        if (storageType) {
            let dataLocationComponent = [];
            dataLocationComponent.push(...getRetentionDaysTextField());
            dataLocationComponent.push(getAAStreamLocationPrefixFields(props.formikProps, props.isReadOnly));
            dataLocationComponent.push(getAAStreamExpiryDaysField(props.formikProps, props.isReadOnly));
            return dataLocationComponent;
        }
    };
    return (React.createElement(StepContainer, { className: "create-datalocation-info-tab" },
        !props.isUpdateDataSource && (React.createElement(FormHeading, { pageTitle: CreateStepTitle.Location }, "This is where you enter details about the location of your data.")),
        React.createElement(FormSection, null,
            React.createElement(DropdownField, { label: "Data type", name: `storageType`, ariaLabel: "Data type", placeholder: getPlaceHolder(dataSourceCreateComponentsName.datalocationinfo, 'datatype'), options: optionList, selectedKey: (_f = (_e = props.formikProps) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.storageType, required: true, isReadOnly: !!props.isReadOnly, onChange: (ev, option) => {
                    var _a;
                    (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.setFieldValue('storageType', option === null || option === void 0 ? void 0 : option.data.storageType, true);
                    _handleDataTypeChange(option);
                } }),
            dataLocationComponent,
            React.createElement(DataLocationAuthtencationFileds, { ...props }),
            _generateOptionalFields())));
}
export default DataLocationInfoComponent;

//# sourceMappingURL=DataLocationInfoComponent.js.map
